import { createContext } from 'react';
import { ConfigurationRouter } from '../types';

export const Context = createContext<null | {
  configuration: ConfigurationRouter;
}>(null);
